import styled from "styled-components";
import {Layout, PageHeader} from "antd";

export const ThemeContainer = styled(Layout)`
    min-height: 100vh;
    margin: 0;
    padding: 0;
`;

export const ThemeHeader = styled(PageHeader)`
    background: #fff;
    z-index: 2;
    box-shadow: rgba(75, 74, 73, 0.2) 0px 1px 4px 1px;
    margin: 0;
    padding: 0;
`;

export const ThemeContent = styled(Layout.Content)`
    overflow: hidden;
    margin: 0;
    padding: 0;
`;

export const ThemeChildrenContainer = styled.div`
    background: #fff;
    min-height: max(100vh, 500px);
    position: relative;
    margin: 0;
    padding: 0;
`;
